
import EventBus from '@/helpers/EventBus'
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'RequestCodeLink' })
export default class extends Vue {
  onclick() {
    EventBus.$emit('request-code-link-clicked')
  }
}
